import { REFER_SELECT_TYPE } from './referType';
import ReferViewMeta from './ReferViewMeta';
import DataLoader from './data_loader';
import _ from 'lodash';
import { runInAction } from 'mobx'
import { getJsonObj } from '../../utils'
import { observable, action, makeObservable, reaction } from 'mobx';
import { isMultiple } from './formatter';

export default class ReferContext {
    // 内置参照
    static buildMetaRefer({ equipment, selectType, onOk, onClose, props }) {
        const view = new ReferViewMeta(equipment).getViewComponent();
        return ReferContext.buildRefer({ referView: view, selectType, onOk, onClose, props, equipment });
    }

    // 用户自定义的参照
    static buildRefer({ referView, selectType, onOk, onClose, props, equipment }) {
        const rs = new ReferContext({ referView, selectType, onOk, onClose, props, equipment });
        return rs;
    }

    // 初始化
    constructor({ referView, selectType='single', onOk, onClose, props, equipment }) {
        this.props = props;
        this.value = props.value;
        this.equipment = equipment;
        this.refCode = this.props.refCode;
        this.selectType = REFER_SELECT_TYPE.from(selectType);
        this.isMultiple = isMultiple(props) // 是否是多选
        this.referView = referView;
        this.referView.setReferContext(this);
        this.onOk = onOk;
        this.onClose = onClose;
        this.dataSource = []
        this.metaDataObjCache = {};

        if (this.isMultiple && Array.isArray(this.value)) { // 多选
            this.currentValue = this.value || [];
        } else { // 单选
            this.currentValue = this.value ? [this.value] : []
        }

        makeObservable(this, {
            currentValue: observable,
            value: observable
        })

        reaction(
            () => this.value,
            (value) => {
                if (this.isMultiple && Array.isArray(value)) { // 多选
                    this.currentValue = value || [];
                } else { // 单选
                    this.currentValue = value ? [value] : []
                }
            }
        );
    }

    get metaDataObj() {
        return this.metaDataObjCache[this.refCode] ?? { cEntityKeyFld: this.props.cEntityKeyFld }
    }

    // 打开参照
    open(ele) {
        const id = 'common-picker-' + ele
        if (!document.getElementById(id)) {
            const container = document.createElement('div')
            container.id = id
            document.body.append(container)
        }
        this.referView.open(document.getElementById(id));
    }

    // 关闭参照
    close() {
        if (this.isMultiple && Array.isArray(this.value)) { // 多选
            this.currentValue = this.value || [];
        } else { // 单选
            this.currentValue = this.value ? [this.value] : []
        }
        // 用户自定义关闭事件
        this.props.onClose?.();
        this.onClose?.()
    }

    // 获取参照数据
    getListData(param) {
        return new DataLoader(this).getDataLoader(param);
    }

    // 获取参照元数据
    getMetaData() {
        return new DataLoader(this).getMetaLoader();
    }

    // 确定
    async okClick() {
        // let oldValue;
        // if (this.isMultiple) { // 多选
        //     oldValue = this.props.value
        // } else { // 单选
        //     const oldKey = this.props.value?.[this.metaDataObj.cEntityKeyFld]; // 旧主键值
        //     this.oldKey = oldKey;
        //     oldValue = this.props.value // 旧显示值
        // }
        // 关闭弹窗this.props
        let elementId = document.getElementById(`common-picker-${this.props?.alias}`);
        elementId && ReactDOM.unmountComponentAtNode(elementId); // 卸载弹窗组件

        // 用户自定义确定事件
        this.props.onOk?.(this.currentValue, {key: this.metaDataObj?.cEntityKeyFld});
        this.onOk?.(this.currentValue, {key: this.metaDataObj?.cEntityKeyFld});

        // 更新显示值
        if (this.isMultiple) { // 多选
            this.props.onChange?.(this.currentValue)
        } else { // 单选
            const value = this.currentValue[0] || {};
            this.props.onChange?.(value)
        }
    }

    // 清除当前值
    clearValue(isClose) {
        this.currentValue = [];
        if (isClose === 'close') {
            this.okClick();
        }
    }

    // 单选--选择参照数据并且立即触发OK事件(移动端时用)
    selectWithOk(selectList) {
        this.select(selectList);
        this.okClick();
    }

    // 选择参照数据
    select(selectList) {
        this.currentValue = selectList;
    }

    // 获取当前已选值
    getCurrentValue () {
        return this.currentValue;
    }

    // 无Input框时请求回调(兼容脚本打开弹窗方案)
    getReferData = (callback) => {
        this.getReferDataCallback = callback;
    }
    onGetReferData = (callback) => {
        this.getReferDataCallback = callback;
    }
}
